"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
// bs-table-item-selection-actions

var _require = require('lodash'),
  get = _require.get;
var tableItemSelectionActionsCtrl = /* @ngInject */function tableItemSelectionActionsCtrl($route, $routeParams, $scope, $q, $rootScope, $window, $timeout, eventService, metadataService, bulkUpdateService, metricsService, modalService) {
  var _this = this;
  this.$window = $window;
  this.$timeout = $timeout;

  // ⚑
  // TODO: Refactor bad directive practice
  var eventId = $routeParams.eventId;
  var event = eventService.decorateScope(eventId);

  // batch selection actions to be used in the pax & agenda tables
  var rows = function rows() {
    return $scope.rowCollection;
  };
  var getAllSelectedItems = function getAllSelectedItems() {
    return _.where(rows(), {
      isSelected: true
    });
  };
  var getDocFpType = function getDocFpType() {
    return (_.first(rows()) || {}).fp_type;
  };
  var deleteMetaPropsInRow = function deleteMetaPropsInRow(row) {
    var privateFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var fieldsToDelete = _.union(
    // just to be safe (these two are set in the controller for display purposes)
    ['isInvited', 'isActivated', 'actcode'], privateFields);
    return _.omit(row, fieldsToDelete);
  };
  var getPrivateFields = function getPrivateFields() {
    var metadata = metadataService.getCachedMetadataForTypeAsArray(eventId, getDocFpType());
    return metadata.filter(function (field) {
      return field.crypt;
    }).map(function (field) {
      return field.field;
    });
  };
  $scope.getSelectedItemCount = function () {
    return getAllSelectedItems().length;
  };
  $scope.getDeleteButtonLabel = function () {
    if (getDocFpType() === 'person') {
      return 'Deactivate and cancel';
    }
    return 'Delete';
  };
  $scope.shouldShowSelectionOperationsButtons = function () {
    $scope.somethingSelected = Boolean(_.findWhere(rows(), {
      isSelected: true
    }));
    // try to do something a bit optimised
    return $scope.somethingSelected;
  };
  $scope.hideSelectedItemsInList = function () {
    var selectedItems = getAllSelectedItems();
    var _rows = _.without.apply(_, [rows()].concat(selectedItems));
    return angular.copy(_rows, rows());
  };
  $scope.shouldShowHideShowButtons = function () {
    return getDocFpType() === 'person';
  };
  $scope.shouldShowPaxRequestButtons = function () {
    return getDocFpType() === 'pax-request';
  };
  $scope.shouldShowDeleteButtons = function () {
    var currentRouteDescriptor = $route.current !== null ? $route.current.$$route : null;
    var blueprintController = get(currentRouteDescriptor, 'blueprintMetadata.controller');
    var hideDelete = get(blueprintController, 'routeOptions.crudOpts.hideDelete');
    return !hideDelete;
  };
  function initButtons() {
    return _initButtons.apply(this, arguments);
  }
  function _initButtons() {
    _initButtons = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return metadataService.getCachedDuplicateFlagForType(eventId, getDocFpType());
          case 2:
            $scope.shouldShowDuplicateButton = _context.sent;
            _context.next = 5;
            return metadataService.getCachedBulkEditFlagForType(eventId, getDocFpType());
          case 5:
            $scope.shouldShowBulkEditButton = _context.sent;
            $scope.timeShiftFields = metadataService.getCachedMetadataForTypeAsArray(eventId, getDocFpType()).filter(function (field) {
              return field._timeshift;
            });
            _context.next = 9;
            return window.BSTG.services.metadata.isFpTypeTimeShiftable(eventId, getDocFpType());
          case 9:
            $scope.shouldShowTimeShiftButton = _context.sent;
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _initButtons.apply(this, arguments);
  }
  initButtons();
  $scope.applyFpStatusToSelectedItems = function (fpStatusToApply, attributeName) {
    if (!attributeName) {
      attributeName = 'fp_status';
    }
    var promises = [];
    var selectedItems = getAllSelectedItems();
    var privateFields = getPrivateFields();
    selectedItems.forEach(function (_row) {
      delete _row.isSelected;
      var clonedRow = deleteMetaPropsInRow(_.clone(_row), privateFields);
      clonedRow[attributeName] = fpStatusToApply;
      var p = bulkUpdateService.updateDoc(eventId, event.node, _row.fp_type, clonedRow);
      promises.push(p);
      p.then(function () {
        return _row[attributeName] = clonedRow[attributeName];
      });
    });
    return $q.all(promises).then(function () {
      $scope.onStatusChange({
        status: fpStatusToApply,
        selectedItems: selectedItems
      });
      return $scope.$emit('selectionChange');
    });
  };

  /** @param {'approve' | 'deny'} action */
  $scope.setPaxRequestStatus = function (action) {
    var items = getAllSelectedItems() || [];
    if (!items.length || !['approve', 'deny'].includes(action)) {
      return;
    }
    var msgAction = action === 'approve' ? 'approved' : 'denied';
    var msg = "The selected requests will be ".concat(msgAction, ". Proceed?");
    if (!confirm(msg)) {
      return;
    }
    var paxRequestIds = items.map(function (d) {
      return d._id;
    });
    window.BSTG.services.pax.setPaxRequestStatus(eventId, paxRequestIds, action).then(function () {
      return _this.$timeout(function () {
        return $route.reload();
      }, 1000);
    }).catch(function () {
      return alert('The requests could not be approved');
    });
  };
  $scope.deleteSelectedItems = function () {
    var items = getAllSelectedItems() || [];
    if (!items.length) {
      return;
    }
    if (!confirm('The selected items will be removed or deactivated. Proceed?')) {
      return;
    }
    if (getDocFpType() === 'person') {
      return $scope.applyFpStatusToSelectedItems('cancelled');
    } else {
      // the app side expects docs to have been actually deleted if they're not pax
      // we can safely assume that all fp_types are the same here
      var fpType = items[0].fp_type;
      var fpExtIds = items.map(function (_row) {
        return _row.fp_ext_id;
      });
      return bulkUpdateService.deleteDocs(eventId, event.node, fpType, fpExtIds).then(function () {
        $rootScope.setFlashMessage('The selected items were removed.');
        $scope.hideSelectedItemsInList();
        $scope.onDeleteOrDesactivate({
          selectedItems: items
        });
        return $route.reload();
      }, function () {
        return alert('Error! The selected items could not be deleted. Do they have ids?');
      });
    }
  };
  $scope.openModalDuplicate = function () {
    var items = getAllSelectedItems() || [];
    var fpType = getDocFpType();
    if (!items.length) {
      return;
    }
    metricsService.track('duplicate_start', {
      countSelectedItems: items.length,
      dataType: fpType
    });
    modalService.openModal({
      scope: {
        selectedItems: items,
        dataType: fpType,
        eventId: eventId
      },
      templateUrl: '/static/partials/components/modal-duplicate.html'
    }).then(function () {
      return _this.$timeout(function () {
        return _this.$window.location.reload();
      }, 1500);
    });
  };
  $scope.openModalBulkEdit = function () {
    var items = getAllSelectedItems() || [];
    var fpType = getDocFpType();
    if (!items.length || items.length < 2) {
      return;
    }
    metricsService.track('bulk_edit_start', {
      countSelectedItems: items.length,
      dataType: fpType
    });
    var metadataForType = metadataService.getCachedMetadataForTypeAsArray(eventId, fpType).filter(function (field) {
      return field._bulk_edit !== false && field.kind !== 'custom';
    });
    var metadataFields = metadataService.filterDuplicateTargetsExceptionsFields(metadataForType);
    modalService.openModal({
      scope: {
        selectedItems: items,
        dataType: fpType,
        metadataFields: metadataFields,
        eventId: eventId
      },
      templateUrl: '/static/partials/components/modal-bulk-edit.html'
    }).then(function () {
      // need a better way to reload the results
      // $route.reload seems to only reloads the list already created, and we need to refresh the whole list
      _this.$timeout(function () {
        return _this.$window.location.reload();
      }, 1500);
    });
  };
  $scope.openModalTimeShift = function () {
    var items = getAllSelectedItems() || [];
    var fpType = getDocFpType();
    if (!items.length) {
      return;
    }
    metricsService.track('time_shift_start', {
      countSelectedItems: items.length,
      dataType: fpType
    });
    modalService.openModal({
      scope: {
        selectedItems: items,
        eventId: eventId,
        dataType: fpType,
        timeShiftFields: $scope.timeShiftFields
      },
      templateUrl: '/static/partials/components/modal-time-shift.html'
    }).then(function () {
      return _this.$timeout(function () {
        return _this.$window.location.reload();
      }, 1500);
    });
  };
  var bulkAssociationFields = metadataService.getCachedMetadataForTypeAsArray(eventId, getDocFpType()).filter(function (mdField) {
    return mdField.kind === 'external' && (!mdField.kind_options || mdField.kind_options.type !== 'targets-exceptions');
  });
  $scope.getFieldsForBulkAssociation = function () {
    return bulkAssociationFields;
  };
  $scope.closeBulkAssociationModalAndPerformAssociation = function () {
    var selectedBulkAssociationField = $scope.selectedBulkAssociationField;
    if (!selectedBulkAssociationField) {
      return $scope.showBulkAssociationModal = false;
    }
    if (!confirm('This will associate the selected items with the one you have chosen. Are you sure?')) {
      return;
    }
    var getSelectedItemIdValue = function getSelectedItemIdValue(item, fieldDescriptor) {
      var idField = (fieldDescriptor.kind_options ? fieldDescriptor.kind_options.id_field : undefined) || 'fp_ext_id';
      return item[idField];
    };
    $scope.bulkAssociationInProgress = true;
    // loop through the selected items and make the appropriate associations
    var items = getAllSelectedItems();
    items.forEach(function (item) {
      var val = getSelectedItemIdValue($scope.selectedBulkAssociationItem, selectedBulkAssociationField);
      var singleDoc = (selectedBulkAssociationField.kind_options || {}).single_doc;
      if (singleDoc) {
        item[selectedBulkAssociationField.field] = val;
      } else {
        var arr = item[selectedBulkAssociationField.field];
        if (_.isArray(arr)) {
          if (!arr.includes(val)) {
            arr.push(val);
          }
        } else {
          item[selectedBulkAssociationField.field] = [val];
        }
      }
      if (item.isSelected) {
        return delete item.isSelected;
      }
    });
    // and save 'em all up
    return bulkUpdateService.createDocs(eventId, event.node, getDocFpType(), items, {
      keepId: true
    }).then(function () {
      return $scope.showBulkAssociationModal = $scope.bulkAssociationInProgress = false;
    }, function () {
      $scope.bulkAssociationInProgress = false;
      return alert('An error occurred.');
    });
  };
  $scope.$watch('selectedBulkAssociationField', function (selectedFieldDescriptor) {
    if (!_.isObject(selectedFieldDescriptor)) {
      return;
    }
    var type = (selectedFieldDescriptor.kind_options || {}).type;
    return eventService.getEventDocsByType(event, type).then(function (data) {
      return $scope.bulkAssociationItems = data.data;
    }, function () {
      return alert('An error occurred.');
    });
  });
};
tableItemSelectionActionsCtrl.$inject = ["$route", "$routeParams", "$scope", "$q", "$rootScope", "$window", "$timeout", "eventService", "metadataService", "bulkUpdateService", "metricsService", "modalService"];
module.exports = function () {
  return {
    transclude: true,
    scope: {
      rowCollection: '=',
      showPaxArrivedButton: '=',
      hideAssociateWithOtherItems: '=',
      somethingSelected: '=?',
      onStatusChange: '&',
      onDeleteOrDesactivate: '&',
      transclude: '='
    },
    templateUrl: '/static/partials/components/table-item-selection-actions.html',
    controller: tableItemSelectionActionsCtrl
  };
};